import { render } from "./TheSidebarCategories.vue?vue&type=template&id=173ba4d6&scoped=true"
import script from "./TheSidebarCategories.vue?vue&type=script&lang=js"
export * from "./TheSidebarCategories.vue?vue&type=script&lang=js"

import "./TheSidebarCategories.vue?vue&type=style&index=0&id=173ba4d6&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173ba4d6"]])

export default __exports__